import { render, staticRenderFns } from "./StoryHistoryDrawer.vue?vue&type=template&id=07f88f69&"
import script from "./StoryHistoryDrawer.vue?vue&type=script&lang=js&"
export * from "./StoryHistoryDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports